var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pt-0"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row food-section"},[_c('div',{staticClass:"col-xl-12 p-0 col-lg-12"},[_c('OrderDetail')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }